module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"the-art-of-surf\"-in-torrance-california-07bfe2f71f44473c2cdd316ef0428176.png";